import { defineNuxtPlugin } from 'nuxt/app';

type Callback = (arg?: unknown) => unknown;

// functional approach
function addEvent (
  evts: Record<string, Callback[] | undefined>,
  evtName: string,
  callbacks: Callback[],
) {
  if (!evts[evtName]) {
    evts[evtName] = [];
  }
  evts[evtName].push(...callbacks);
}
function removeEvent (
  evts: Record<string, Callback[] | undefined>,
  evtName: string,
  callbacks: Callback[],
) {
  if (evts[evtName]) {
    if (callbacks?.length) {
      evts[evtName] = evts[evtName].filter(cb => !callbacks.includes(cb));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete evts[evtName];
    }
  }
}
function triggerEvent (
  evts: Record<string, Callback[] | undefined>,
  evtName: string,
  evtPayload: unknown,
) {
  if (evts[evtName]) {
    for (let i = 0; i < evts[evtName].length; i++) {
      evts[evtName][i](evtPayload);
    }
  }
}

// obj oriented approach
class AwEvents {
  _events: Record<string, Callback[] | undefined> = {};

  addEvent (eventName: string, ...callbacks: Callback[]) {
    addEvent(this._events, eventName, callbacks);
  }

  removeEvent (eventName: string, ...callbacks: Callback[]) {
    removeEvent(this._events, eventName, callbacks);
  }

  triggerEvent (eventName: string, evtPayload?: unknown) {
    triggerEvent(this._events, eventName, evtPayload);
  }
}

export default defineNuxtPlugin(function (nuxtApp) {
  nuxtApp.provide('awEvents', new AwEvents());
});

// https://nuxt.com/docs/guide/directory-structure/plugins#typing-plugins
declare module '#app' {
  interface NuxtApp extends AwEventsPlugin {}
}

declare module 'vue' {
  interface ComponentCustomProperties extends AwEventsPlugin {}
}

interface AwEventsPlugin {
  $awEvents: AwEvents,
}
